export const MESSAGE = {
  ERROR: {
    BAD_REQUEST: "不正なリクエストです。",
    CONFLICT: "既に存在する{label}です。",
    EXPIRED: "有効期限が過ぎています。",
    FAILED: "{label}に失敗しました。",
    FAILED_ACTION: "{label}の{action}に失敗しました。",
    FORBIDDEN: "アクセス権限がありません。",
    NOT_FOUND: "{label}が存在しません。",
    NOT_FOUND_QUERY: "該当する{label}が存在しません。",
    NOT_FOUND_TARGET: "{label}に{target}が存在しません。",
    REQUIRED: "{label}は必須です。",
    UNADDED: "{label}に追加するものがありません。",
    UNAUTHORIZED: "再度ログインしてください。",
    UNAVAILABLE: "メンテナンス中です。",
    UNEXPECTED: "予期せぬエラーが発生しました。",
    UNSELECTED: "{label}が選択されていません。",
  },
  INFO: {},
  SUCCESS: {
    ADDED: "{label}を追加しました。",
    ADDED_ALL: "{label}をすべて追加しました。",
    ADDED_ALL_TO: "{label}にすべて追加しました。",
    ADDED_TO: "{label}に追加しました。",
    APPLIED: "{label}を申請しました。",
    APPLIED_ALL: "{label}をすべて申請しました。",
    APPROVED: "{label}を承認しました。",
    APPROVED_ALL: "{label}をすべて承認しました。",
    CANCELED: "{label}をキャンセルしました。",
    CANCELED_ALL: "{label}をすべてキャンセルしました。",
    CHANGED: "{label}を変更しました。",
    CHANGED_ALL: "{label}をすべて変更しました。",
    CHANGED_TO: `{label}を{target}に変更しました。`,
    CHANGED_TO_ALL: `{label}をすべて{target}に変更しました。`,
    COMPLETED: "{label}が完了しました。",
    COMPLETED_ALL: "{label}がすべて完了しました。",
    CREATED: "{label}を作成しました。",
    CREATED_ALL: "{label}をすべて作成しました。",
    DELETED: "{label}を削除しました。",
    DELETED_ALL: "{label}をすべて削除しました。",
    DELIVERED: "{label}を配信しました。",
    DELIVERED_ALL: "{label}をすべて配信しました。",
    DISABLED: "{label}を無効にしました。",
    DISABLED_ALL: "{label}をすべて無効にしました。",
    DONE: "{label}しました。",
    ENABLED: "{label}を有効にしました。",
    ENABLED_ALL: "{label}をすべて有効にしました。",
    INVITED: "{label}を招待しました。",
    INVITED_ALL: "{label}をすべて招待しました。",
    REGISTERED: "{label}を登録しました。",
    REGISTERED_ALL: "{label}をすべて登録しました。",
    RESET: "{label}をリセットしました。",
    RESET_ALL: "{label}をすべてリセットしました。",
    REVOKED: "{label}を取り消しました。",
    REVOKED_ALL: "{label}をすべて取り消しました。",
    SAVED: "{label}を保存しました。",
    SAVED_ALL: "{label}をすべて保存しました。",
    SENT: "{label}を送信しました。",
    UPDATED: "{label}を更新しました。",
    UPDATED_ALL: "{label}をすべて更新しました。",
    UPLOADED: "{label}をアップロードしました。",
  },
  VALIDATE: {
    AGREE: "{label}に同意してください。",
    INT: "{label}は整数で入力してください。",
    MATCH: "{label}が一致しません。",
    MAX_LENGTH: "{label}は{count}文字以内で入力してください。",
    MAX_SIZE: "{label}は{size}以内で選択してください。",
    MIN_LENGTH: `{label}は{count}文字以上で入力してください。`,
    PATTERN: "{label}を正しい形式で入力してください。",
    POSITIVE: "{label}は正の数で入力してください。",
    RANGE_LENGTH: "{label}は{min}から{max}文字で入力してください。",
    REQUIRED: "{label}を入力してください。",
    SELECT: "{label}を選択してください。",
    SELECT_ONCE: "{label}はどちらか一方を選択してください。",
  },
  WARNING: {
    ACTION: "{label}します。よろしいですか？",
    CHANGE: "{label}を変更します。よろしいですか？",
    CHANGE_ACTION: "{label}は、{action}されています。本当に変更しますか？",
    CHANGE_ALL: "{label}をすべて変更します。よろしいですか？",
    DELETE: "{label}を削除します。よろしいですか？",
    DELETE_ACTION: "{label}は、{action}されています。本当に削除しますか？",
    DELETE_ALL: "{label}をすべて削除します。よろしいですか？",
    DISCARD: "{label}が破棄されます。それでも実行しますか？",
    DISCARD_DO_NOT_ACTION:
      "{label}は、{action}されていません。本当に破棄しますか？",
    RESET: "{label}をリセットします。よろしいですか？",
    RESET_ACTION: "{label}は、{action}されています。本当にリセットしますか？",
    RESET_ALL: "{label}をすべてリセットします。よろしいですか？",
  },
}
